// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"yN-z","carouselContainer":"zN-z"};